import { render, staticRenderFns } from "./FirmeDostava.vue?vue&type=template&id=5b2a0024&scoped=true&"
import script from "./FirmeDostava.vue?vue&type=script&lang=js&"
export * from "./FirmeDostava.vue?vue&type=script&lang=js&"
import style0 from "./FirmeDostava.vue?vue&type=style&index=0&id=5b2a0024&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2a0024",
  null
  
)

export default component.exports